<script setup lang="ts">
    import { DisplayStyle, TextDisplayStyle } from '../../Enums/UiEnums';
    import { bootstrapBadgeClass } from '../../lib/StyleHelpers';
    import { computed } from 'vue';

    const props = withDefaults(defineProps<{
            displayStyle?: DisplayStyle,
            title?: string,
            textDisplayStyle?: DisplayStyle|TextDisplayStyle,
            overrideStyle?: string
        }>(), {
            displayStyle: DisplayStyle.Primary,
    });

    const spanClass = computed(() =>
    {
        if (props.overrideStyle) {
            return [
                props.overrideStyle,
                "badge",
                "me-1"
            ];
        }
        else {
            return [
                bootstrapBadgeClass(props.displayStyle, props.textDisplayStyle),
                "me-1"
            ];
        }
    });

</script>

<template>
    <span :class="spanClass" :title="title">
        <slot></slot>
    </span>
</template>